export default "__VITE_ASSET__zRUCu0IR__"